import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { OkAloneService } from 'src/app/ok-alone.service';


import * as _ from 'lodash-es';
declare var require: any;


@Component({
  selector: 'app-monitors-upload',
  templateUrl: './monitors-upload.component.html',
  styleUrls: ['./monitors-upload.component.scss']
})
export class MonitorsUploadComponent implements OnInit {


  falseVal = false;



  uploader:FileUploader;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;

  monitors:any = null;
  monitors2:any = null;

  step = 1;

  upload_errors = false;

  file_error = "";

  extra_fields = ['','','','','']

  extra_field_options = [
    {field:"",name:"Choose Field"},
    {field:"admin",name:"Is Admin"},
    {field:"privacy",name:"Extended Privacy"},
    {field:"timezone",name:"Timezone Code"},
    {field:"country",name:"Country Code"},
    {field:"phone2",name:"Autocall Phone Number"},
  ];

  extra_field_valid = true;

  welcome_loading = false;
  
 
  constructor (public okService:OkAloneService){

 
    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    let url = this.okService.getUrl('monitors/upload');
    this.uploader = new FileUploader({url: url});
 
    this.response = '';

    this.setupLoader();
  }

  setupLoader(){

    let url:any = this.okService.getUrl('monitors/upload');
    //console.log(url);

    let token = "Bearer "+this.okService.session.token;
    //console.log(token);

    let headers: { name: string; value: string }[] = [];
    if (this.okService.session.cid) {
      headers.push({ name: 'cid', value: this.okService.session.cid });
    }

    this.uploader = new FileUploader({
      url: url,
      authToken: token,
      headers: headers,
      itemAlias:"upload",
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      // formatDataFunctionIsAsync: true,
      // formatDataFunction: async (item:any) => {
      //   return new Promise( (resolve, reject) => {
      //     resolve({
      //       name: item._file.name,
      //       length: item._file.size,
      //       contentType: item._file.type,
      //       date: new Date()
      //     });
      //   });
      //}
    });

    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });
 
    this.uploader.response.subscribe( res => {

      this.file_error = "";

      let data = JSON.parse(res);
      //console.log(data);

      if(data['error']){
        this.file_error = data['error'];
      }else{
        
      this.upload_errors = false;
      this.monitors = JSON.parse(res);
      //console.log(this.monitors);

      let self = this;
      _.forEach(this.monitors, function(monitor:any) {
        if(monitor.errors.length > 0){
          self.upload_errors = true;
        }
        
      });
      
      // Check monitors for errors
      this.step =2;
      }


    } );


  }

  
  
  uploadMonitors(){
    //console.log(this.monitors);  

    //console.log(this.extra_fields);      
    
    this.extra_field_valid = true;

    if(this.monitors[0].extra_field_1){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[0]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.monitors[0].extra_field_2){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[1]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.monitors[0].extra_field_3){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[2]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.monitors[0].extra_field_4){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[3]!=''
        //console.log(this.extra_field_valid);
    }
    if(this.monitors[0].extra_field_5){
        this.extra_field_valid = this.extra_field_valid && this.extra_fields[4]!=''
        //console.log(this.extra_field_valid);
    }
    //console.log(this.extra_field_valid);

    if(this.extra_field_valid){

      
      this.okService.post("monitors/upload",{"monitors":this.monitors,"extra_fields":this.extra_fields})
      .subscribe((data) => {

        console.log('monitors',data.body);

        this.monitors2 = data.body;
        this.step = 3;


      });
    }
  }

  ngOnInit(): void {
  }
 
  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }
 
  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }

  reset(){
    this.upload_errors = false;
    this.monitors = null;
    this.setupLoader();
    this.step = 1;
  }

  sendWelcome(){

    this.welcome_loading = true;

    let ids:any = [];
    _.forEach(this.monitors2, function(monitor:any) {
      ids.push(monitor.id)
    });
    //console.log(ids);



    this.okService.post("monitors/welcomes",{"ids":ids})
    .subscribe((data) => {

      this.okService.setAlert("The monitor welcome emails have been sent","success")

      this.welcome_loading = false;

    });

  
  }
}
